// extracted by mini-css-extract-plugin
export default {"createPublicationButton":"styles_createPublicationButton__iX41b","iconNewPost":"styles_iconNewPost__16Nhq"};